import { render, staticRenderFns } from "./TextField.vue?vue&type=template&id=06f642fe&"
import script from "./TextField.vue?vue&type=script&lang=js&"
export * from "./TextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports